import { lazy } from "react";

// project imports
import AuthGuard from "utils/route-guard/AuthGuard";
import MinimalLayout from "layout/MinimalLayout";
// import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";

const AuthLogin = Loadable(lazy(() => import("views/authentication/login")));
const AuthLogout = Loadable(lazy(() => import("views/authentication/logout")));

// ==============================|| AUTH ROUTING ||============================== //

const AuthenticationRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MinimalLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "login",
      element: <AuthLogin />,
    },
    {
      path: "logout",
      element: <AuthLogout />,
    },
  ],
};

export default AuthenticationRoutes;
